import script from "./mobile-check.vue?vue&type=script&setup=true&lang=js"
export * from "./mobile-check.vue?vue&type=script&setup=true&lang=js"

import "./mobile-check.vue?vue&type=style&index=0&id=d48f1644&lang=scss&scoped=true"

import exportComponent from "/home/hudson/workspace/103261_ib-gwms-customer-xc-devops/ib-gwms-customer-xc-devops/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d48f1644"]])

export default __exports__